// Header 2026 (sections/mbb-kopf.liquid): drawer, sub-menus, search dialog with
// suggestions, hide on scroll down. No framework, no custom elements. The menus work
// without this file too — they are <details>.
;(() => {
  const kp = document.getElementById('kp')
  if (!kp) return
  const sektion = kp.closest('.shopify-section') || kp.parentElement
  const knopf = kp.querySelector('.kp__menue-knopf')
  const nav = document.getElementById('kp-nav')
  const suche = document.getElementById('kp-suche')
  const handy = matchMedia('(max-width: 989px)')
  const oben = [...nav.querySelectorAll(':scope > ul > li > details')]
  const gruppen = [...nav.querySelectorAll('.kp-tafel details')]
  const knopfLabel = knopf.getAttribute('aria-label')

  /* ── Phone: menu as a drawer ───────────────────────────────────── */
  const istOffen = () => sektion.classList.contains('ist-offen')
  const setzeMenue = (auf) => {
    if (auf) {
      sektion.classList.remove('ist-weg')
      kp.style.setProperty('--kp-oben', Math.max(0, kp.getBoundingClientRect().bottom) + 'px')
    }
    sektion.classList.toggle('ist-offen', auf)
    knopf.setAttribute('aria-expanded', String(auf))
    knopf.setAttribute('aria-label', auf ? knopf.dataset.zu : knopfLabel)
    document.documentElement.style.overflow = auf ? 'hidden' : ''
  }
  knopf.addEventListener('click', () => setzeMenue(!istOffen()))
  kp.querySelector('.kp-schleier').addEventListener('click', () => setzeMenue(false))
  // The cart drawer sits above the header; close the menu before it opens.
  document.getElementById('cart-icon-bubble')?.addEventListener('click', () => setzeMenue(false))

  /* ── Desktop: one sub-menu at a time, click beside or Esc closes ── */
  oben.forEach((d) => d.addEventListener('toggle', () => {
    if (d.open && !handy.matches) oben.forEach((x) => { if (x !== d) x.open = false })
  }))
  document.addEventListener('click', (e) => {
    if (!handy.matches && !nav.contains(e.target)) oben.forEach((d) => { d.open = false })
  })
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    const offen = oben.find((d) => d.open)
    if (offen && !handy.matches) { offen.open = false; offen.querySelector('summary').focus() }
    if (istOffen()) { setzeMenue(false); knopf.focus() }
  })

  // Groups of a panel: columns on the desktop (always open), foldable on the phone.
  const passe = () => {
    gruppen.forEach((g) => { g.open = !handy.matches })
    oben.forEach((d) => { d.open = false })
    if (!handy.matches) setzeMenue(false)
  }
  passe()
  handy.addEventListener('change', passe)
  gruppen.forEach((g) => g.querySelector('summary').addEventListener('click', (e) => { if (!handy.matches) e.preventDefault() }))

  /* ── Search ────────────────────────────────────────────────────── */
  // "Bearbrick" is in every one of 2,261 titles: in a search of several words it only
  // brings in a thousand foreign hits and pushes the wanted model out (measured
  // 04.11.2026: "pennywise" 4 hits, "bearbrick pennywise" 1,000). Alone it stays.
  const GATTUNG = /(^|[\s,;:/-])be[@a]r\s?bricks?(?=$|[\s,;:/-])/gi
  const kern = (q) => {
    const ohne = q.replace(GATTUNG, ' ').replace(/\s+/g, ' ').trim()
    return ohne.length >= 2 ? ohne : q.trim()
  }
  // Every search form of the shop (header, search page, hero of the home page).
  document.addEventListener('submit', (e) => {
    const form = e.target
    if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"], form[action$="/search"]')) return
    const feld = form.querySelector('input[name="q"]')
    if (feld) feld.value = kern(feld.value)
  }, true)

  const feld = suche.querySelector('input[name="q"]')
  const inhalt = suche.querySelector('[data-kp-ergebnis]')
  const start = inhalt.innerHTML
  const sucheOeffnen = () => {
    setzeMenue(false)
    if (!suche.open) suche.showModal()
    feld.focus()
  }
  kp.querySelector('.kp-i--suche').addEventListener('click', sucheOeffnen)
  suche.querySelector('[data-kp-suche-zu]').addEventListener('click', () => suche.close())
  suche.addEventListener('click', (e) => { if (e.target === suche) suche.close() })

  let abbruch = null
  let warten = 0
  let gezeigt = ''
  const lade = async (begriff) => {
    abbruch?.abort()
    abbruch = new AbortController()
    const url = `${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(begriff)}`
      + '&section_id=mbb-suchvorschau&resources[type]=product,query,collection,page'
      + '&resources[limit]=6&resources[limit_scope]=each'
    suche.classList.add('laedt')
    try {
      const antwort = await fetch(url, { signal: abbruch.signal })
      if (!antwort.ok) throw new Error(String(antwort.status))
      const html = await antwort.text()
      // Only the answer to the term that is in the field now; a late answer to an
      // earlier term must not overwrite a newer one.
      if (kern(feld.value) !== begriff) return
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const teil = doc.querySelector('.shopify-section') || doc.body
      inhalt.innerHTML = teil.innerHTML
      gezeigt = begriff
    } catch (fehler) {
      if (fehler.name !== 'AbortError') inhalt.innerHTML = start
    } finally {
      suche.classList.remove('laedt')
    }
  }
  feld.addEventListener('input', () => {
    clearTimeout(warten)
    const begriff = kern(feld.value)
    if (feld.value.trim().length < 2) { abbruch?.abort(); inhalt.innerHTML = start; gezeigt = ''; return }
    if (begriff === gezeigt) return
    warten = setTimeout(() => lade(begriff), 180)
  })

  /* ── Hide on scroll down, back on scroll up ────────────────────── */
  // --kp-sichtbar tells sticky elements further down (gallery of the product page)
  // how much of the header covers the top of the window right now.
  const wurzel = document.documentElement
  const setzeSichtbar = () => {
    const unten = sektion.classList.contains('ist-weg') ? 0 : Math.max(0, kp.getBoundingClientRect().bottom)
    wurzel.style.setProperty('--kp-sichtbar', Math.round(unten) + 'px')
  }
  let zuletzt = scrollY
  let tick = false
  addEventListener('scroll', () => {
    if (tick) return
    tick = true
    requestAnimationFrame(() => {
      tick = false
      const y = scrollY
      const offen = istOffen() || oben.some((d) => d.open) || suche.open
      if (Math.abs(y - zuletzt) > 4) {
        sektion.classList.toggle('ist-weg', !offen && y > zuletzt && y > 240)
        zuletzt = y
      }
      setzeSichtbar()
    })
  }, { passive: true })
  sektion.addEventListener('transitionend', setzeSichtbar)
  setzeSichtbar()

  // Into the cart: bring the header back so the cart icon is in view, and tell a flight
  // animation (product page 2026) where the icon WILL be — the slide-in has only begun.
  const zeigen = () => { sektion.classList.remove('ist-weg'); setzeSichtbar() }
  document.addEventListener('submit', (e) => { if (e.target instanceof HTMLFormElement && e.target.action.includes('/cart/add')) zeigen() }, true)
  const korbZiel = () => {
    const r = document.getElementById('cart-icon-bubble').getBoundingClientRect()
    const m = new DOMMatrix(getComputedStyle(sektion).transform)
    return { left: r.left, top: r.top - m.f, width: r.width, height: r.height }
  }

  window.mbbKopf = { sucheOeffnen, zeigen, korbZiel }
})()
